const siteStucture = [
  // Old Navigation
  {
    id: `training-ground`,
    title: `Training Ground`,
    href: `/training-ground`,
    iconName: `outline-home`,
    includeInMainMenu: true,
  },

  {
    id: `locker`,
    title: `Locker`,
    href: `/locker`,
    iconName: `outline-dashboard`,
    includeInMainMenu: true,
  },

  {
    id: `my-content`,
    title: `My Content`,
    href: `/locker/my-content`,
    iconName: `outline-add-box`,
    includeInMainMenu: true,
  },


  // Discover
  {
    id: `discover`,
    title: `Discover`,
    href: `/training-ground`,
    iconName: `outline-home`,
    includeInMainMenu: false,
  },

  // Organise
  {
    id: `organise`,
    title: `Organise`,
    href: `/organise`,
    iconName: `outline-dashboard`,
    includeInMainMenu: false,
  },
  {
    id: `calendar`,
    parentId: `organise`,
    title: `Calendar`,
    href: `/locker/calendar`,
    iconName: `outline-calendar`,
    description: `Your coaching schedule`,
  },
  {
    id: `folders`,
    parentId: `organise`,
    title: `Folders`,
    href: `/locker/folders`,
    iconName: `outline-folder`,
    description: `Organise and share folders of content`,
  },
  {
    id: `season-plans`,
    parentId: `organise`,
    title: `Season Plans`,
    href: `locker/season-plans`,
    iconName: `outline-season-plan`,
    description: `Build a season-long curriculum for your team`,
  },

  // Create
  {
    id: `create`,
    title: `Create`,
    href: `/create`,
    iconName: `outline-add-box`,
    includeInMainMenu: false,
  },
  {
    id: `diagram`,
    parentId: `my-content`,
    title: `Create Diagram`,
    href: `/locker/my-content/diagram`,
    iconName: `outline-diagram`,
    iconFill: `pitchdiagram`,
    description: `Use our drag and drop tool to create a practice diagram`,
  },
  {
    id: `practice`,
    parentId: `my-content`,
    title: `Create Practice`,
    href: `/locker/my-content/practice`,
    iconName: `outline-ball`,
    iconFill: `practice`,
    description: `Create a single practice and add your diagrams`,
  },
  {
    id: `document`,
    parentId: `my-content`,
    title: `Create Document`,
    href: `/locker/my-content/document`,
    iconName: `outline-description`,
    iconFill: `document`,
    description: `Create a generic document to add to your folders`,
  },
  {
    id: `session`,
    parentId: `my-content`,
    title: `Create Full Session`,
    href: `/locker/my-sessions`,
    iconName: `outline-session`,
    iconFill: `session`,
    description: `Create a full session and add individual practices`,
  },

  // Manage
  {
    id: `manage`,
    title: `Manage`,
    href: `/manage`,
    iconName: `outline-group`,
    includeInMainMenu: false,
  },
  {
    id: `teams`,
    parentId: `manage`,
    title: `Your Teams`,
    href: `/manage/teams`,
    iconName: `outline-ball`,
    description: `Manage your teams`,
  },
  {
    id: `clubs`,
    parentId: `manage`,
    title: `Your Clubs`,
    href: `/manage/clubs`,
    iconName: `outline-club`,
    description: `Manage your clubs`,
  },

  // Help
  {
    id: `help`,
    title: `Help`,
    href: `https://www.thecoachingmanual.com/help-centre`,
    iconName: `outline-help`,
    includeInMainMenu: true,
  },

  // Account
  {
    id: `profile-info`,
    parentId: `account`,
    title: `Edit Profile`,
    href: `/locker/profile/edit-profile`,
    iconName: `outline-person-pin`,
  },
  {
    id: `profile-theme`,
    parentId: `account`,
    title: `Edit Profile Theme`,
    href: `/locker/profile/edit-profile?select=profile-theme`,
    iconName: `outline-image`,
  },
  {
    id: `details`,
    parentId: `account`,
    title: `Account Details`,
    href: `/account/details`,
    iconName: `outline-alternate-email`,
  },
  {
    id: `plan`,
    parentId: `account`,
    title: `Your Plan`,
    href: `/account/plan`,
    iconName: `swap`,
  },
  // {
  //   id: `billing`,
  //   parentId: `account`,
  //   title: `Billing Details`,
  //   href: `/account/billing`,
  //   iconName: `credit-card`,
  // },
  {
    id: `payment-history`,
    parentId: `account`,
    title: `Payment History`,
    href: `/account/billing/payment-history`,
    iconName: `outline-history`,
    description: `Payment history and invoices`,
  },
  {
    id: `licence-manager`,
    parentId: `account`,
    title: `Licence Manager`,
    href: `/account/licence-manager`,
    iconName: `outline-person-add`,
    description: `Allocate and manage licences`,
  },

];

export default siteStucture;



// WEBPACK FOOTER //
// ./library/app/data/siteStructure.js